// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel___3v2gb","loading":"loading___yguPW"};